import type { LocaleData } from '../../../models/locale/locale-data';

export const data: LocaleData = {
  banner: 'Registrieren Sie Ihre GRATIS',
  heroNumber: '10',
  heroCopy: 'Jahre Garantie auf Ersatzteile*',
  heroSubCopy1: '<b>Registrierung erforderlich</b>',
  heroSubCopy2: 'innerhalb von 60 Tagen nach Gerätekauf',
  registration: 'Jetzt kostenfrei anrufen & aktivieren**',
  ctaPhoneText: '0800 000 3772',
  ctaPhoneLink: 'tel:08000003772',
  phoneSubCopy:
    'Die Registrierung per Anruf ist schnell und bietet Ihnen zusätzliche Informationen zu Ihrer Hersteller- und 10-Jahres-Garantie auf Ersatzteile. Die Öffnungszeiten der Service-Hotline sind Montag bis Freitag 8:00 - 18:30 Uhr.',
  onlineCopy: 'Alternativ können Sie sich auch online registrieren.',
  ctaOnlineText: ' Klicken Sie hier.',
  ctaOnlineLink: 'https://hoover.register-appliance.com/RegistroPorMarca?country=DE&language=de',
  onlineJourneyLaunch: 'Live',
  benefitsHeader: 'Ihre Vorteile der Registrierung:',
  benefits: [
    '10 Jahre lang kostenlose Garantie auf Ersatzteile',
    'Schneller Zugang zu unserem offiziellen Servicenetzwerk',
    'Wichtige Geräte- und Sicherheitsupdates',
    'Rabatte und exklusive Angebote für Produkte, Dienstleistungen und zusätzliche Unterstützung',
  ],
  footerLinks: [
    { text: 'Impressum link', link: '/terms' },
    { text: 'Datenschutzhinweise', link: 'https://www.domesticandgeneral.com/candy' },
    { text: 'Cookie-Richtlinien', link: '/cookies' },
  ],
  footerCopy:
    'Diese Website steht im Eigentum der Domestic & General Group Limited und wird von der Domestic & General Insurance Europe AG, Hagenauer Straße 44, 65203 Wiesbaden, Deutschland, betrieben. Die Domestic & General Insurance Europe AG ist von der Bundesanstalt für Finanzdienstleistungsaufsicht (BaFin) zugelassen und reguliert.',
  heroAsterix: [
    '* Durch das Registrieren Ihres Gerätes innerhalb von 60 Tagen nach Gerätekauf aktivieren Sie Ihre 10 Jahre GRATIS Garantie auf Ersatzteile, inklusive der Jahre, die bereits durch die Herstellergarantie abgesichert sind. Arbeits- und andere eventuelle Reparaturkosten sind ausgeschlossen. Es gelten die Allgemeinen Geschäftsbedingungen, verfügbar unter <0>www.hoover-home.com/de_DE/allgemeinen-geschaftsbedingungen-erweiterte-garantie</0>. Registrierung erforderlich. Ihre gesetzlichen Rechte gegenüber dem Verkäufer des Geräts und Ihre Rechte aus Ihrer 2-jährigen Herstellergarantie bleiben von dieser Aktion unberührt und Sie können diese auch ohne Aktivierung geltend machen.',
  ],
  heroAsterixLinks: [
    'www.hoover-home.com/de_DE/allgemeinen-geschaftsbedingungen-erweiterte-garantie',
  ],
  phoneNumberAsterix: [
    '** Hotline von Domestic & General Insurance Europe AG, in Kooperation mit der Candy Hoover Group S.r.l. Bei Interesse wird Ihnen Domestic & General während der Registrierung Angebote zum Abschluss eines erweiterten Versicherungsschutzes für Ihre Hoover Hausgeräte unterbreiten. Informationen über die Datenschutzhinweise der Candy Hoover Group S.r.l. und der Domestic & General Insurance Europe AG erhalten Sie auf <0>www.hoover-home.com/de_DE/datenschutzrichtlinie/</0> und <1>www.domesticandgeneral.com/candy</1>.',
  ],
  phoneNumberAsterixLinks: [
    'https://www.hoover-home.com/de_DE/datenschutzrichtlinie/',
    'https://www.domesticandgeneral.com/candy',
  ],
  additionalSmallPrint: '',
  languageSwitcherPlaceholder: 'Wählen Sie Ihr Land',
  languageList: [
    { label: 'Deutschland', value: 'de-DE' },
    { label: 'Vereinigtes Königreich', value: 'en-EN' },
    { label: 'Spanien', value: 'es-ES' },
    { label: 'Frankreich', value: 'fr-FR' },
    { label: 'Italien', value: 'it-IT' },
  ],

  cookiePolicy: {
    title: 'Cookie-Richtlinie',
    sections: [
      {
        heading: 'Was sind Cookies?',
        description: [
          'Cookies sind kleine Textdateien, die beim Besuch einer Website an Ihr Gerät gesendet werden. Sie verbleiben auf Ihrem Gerät und werden bei jedem nächsten Besuch an die Website zurückgesendet, von der sie stammen. Cookies erfassen Daten über Sie, wie beispielsweise Ihre Spracheinstellungen oder Anmeldeinformationen. Diese Cookies werden von uns gesetzt und als Erstanbieter-Cookies bezeichnet. Wir verwenden auch Drittanbieter-Cookies. Diese stammen von einer anderen Domain als der der von Ihnen besuchten Website. Diese können uns helfen, unsere Werbung und unser Marketing zu verbessern. Wir verwenden Cookies und andere Tracking-Technologien für folgende Zwecke:',
        ],
      },
      {
        heading: 'Cookies verwalten',
        description: [
          'Um Ihre Cookie-Einstellungen zu ändern, nutzen Sie unser Cookie-Verwaltungstool oder das Sicherheitssymbol auf jeder Seite. Sie können die Verwendung einiger oder aller Cookies und ähnlicher Technologien, die wir auf der Website verwenden, blockieren, indem Sie auf die verschiedenen Cookie-Kategorien klicken. Bitte beachten Sie jedoch, dass dies Ihre Erfahrung mit der Website und unseren Diensten beeinträchtigen kann. Beachten Sie außerdem, dass beim Löschen aller Cookies in Ihrem Browser auch alle Cookies gelöscht werden, die Ihre Einstellungen speichern.',
          'Die meisten Browser erklären Ihnen, wie Sie die Annahme neuer Cookies unterbinden, sich beim Empfang eines neuen Cookies benachrichtigen lassen und Cookies vollständig deaktivieren können. Um bereits in Ihrem Browser gespeicherte Cookies zu löschen, können Sie Ihren Browserverlauf löschen und Cookies löschen oder löschen lassen.',
          'Einige Browser, wie Chrome und Firefox, ermöglichen Ihnen den Inkognito-Modus.Dadurch wird die Datenmenge auf Ihrem Computer begrenzt und alle dauerhaften Cookies werden nach Beendigung Ihrer Browsersitzung automatisch gelöscht.',
          'Alternativ können Sie <0>www.aboutcookies.org</0> besuchen. Dort finden Sie umfassende Informationen zum Entfernen von Cookies in verschiedenen Browsern.',
          'Wenn Sie mehr über Cookies im Allgemeinen erfahren möchten und wissen möchten, wie Sie überprüfen können, welche Drittanbieter Cookies auf Ihrem Mobilgerät aktiviert haben und wie Sie einige dieser Cookies deaktivieren können, besuchen Sie <1>www.networkadvertising.org/mobile-choices</1>. Auf Ihrem Mobilgerät können Sie außerdem,  Ad-Tracking einschränken“ (auf iOS-Geräten) oder,  Interessenbezogene Werbung deaktivieren“ (auf Android-Geräten) auswählen. Dadurch können Sie die Verwendung von Informationen über Ihre App-Nutzung für die Bereitstellung interessenbezogener Werbung einschränken.',
        ],
        links: [
          'https://www.aboutcookies.org',
          'https://www.networkadvertising.org/mobile-choices',
        ],
      },
      {
        heading: 'Websites Dritter',
        description: [
          'Diese Website kann Links zu anderen Websites enthalten oder mit diesen verknüpft sein. Wenn Sie auf die verlinkte Website klicken, verlassen Sie die von uns kontrollierte Website und deren Inhalte und werden mit der Website des Drittanbieters verknüpft. Wir haben keinen Einfluss auf die Inhalte der verlinkten Website und übernehmen keine Verantwortung für deren Informationen und deren Betrieb. Sobald wir Kenntnis davon erhalten, dass dort rechtswidrige oder sonstige Inhalte bereitgestellt werden, werden wir den Link zur verlinkten Website löschen. Die Betreiber der verlinkten Website können Informationen von Ihnen erheben, die sie gemäß ihrer Datenschutzrichtlinie verwenden, die von unserer abweichen kann. Wir haben keinen Einfluss auf die Cookie-Einstellungen der verlinkten Website. Wir empfehlen Ihnen daher, die verlinkten Websites zu besuchen, um weitere Informationen zu deren Cookies und deren Verwaltung zu erhalten.',
        ],
      },
      {
        heading: 'Sicherheit',
        description: [
          'Wir legen großen Wert auf die Sicherheit unserer Website und eine betrugssichere Kundenschnittstelle. Alle ausgetauschten Informationen werden mit SSL-Software verschlüsselt und wir haben alle Anstrengungen unternommen, um sicherzustellen, dass Ihre persönlichen Daten vor unbefugtem Zugriff geschützt sind.',
        ],
      },
    ],
  },
  termsAndConditions: {
    title: 'Impressum & rechtliche Hinweise',
    content: [
      {
        heading: 'Impressum',
        paragraphs: [
          'Domestic & General Insurance Europe AG',
          'Hagenauer Str. 44',
          '65203 Wiesbaden',
          'eingetragen unter HRB Nummer 30859',
          'Amtsgericht Wiesbaden',
        ],
      },
      {
        heading: 'Vorsitzender des Aufsichtsrats: ',
        paragraphs: ['David Tyler'],
      },

      {
        heading: 'Vorstand',
        paragraphs: [
          'Matthew Crummack (Vorsitzender), Matthias Kammermann, Sven Wick',
          'Domestic & General Insurance Europe AG (Domestic & General) ist von der Bundesanstalt für Finanzdienstleistungsaufsicht zugelassen, wird von dieser reguliert, und dort unter der Registernummer 5227 geführt.',
          'Tel: <0>+49 (0)611 308 78 0</0>',
          'Fax: <1>+49 (0)611 308 78 55</1>',
          'Email: <2>infodtc@domesticandgeneral.com</2>',
          'USt-IdNr.: DE322598066',
          'Steuernummer: 014 223 10798',
        ],
        links: ['tel:+49611308780', 'fax:+496113087855', 'mailto:infodtc@domesticandgeneral.com'],
      },
      {
        heading: 'Zuständige Aufsichtsbehörde:',
        paragraphs: [
          'Bundesanstalt für Finanzdienstleistungsaufsicht (BaFin)',
          'Graurheindorfer Straße 108',
          '53117 Bonn',
          'Website: <0>www.bafin.de</0>',
        ],
        links: ['https://www.bafin.de'],
      },
      {
        heading: 'Online-Streitbeilegungsplattform (OS-Plattform)',
        paragraphs: [
          'Die EU stellt eine Plattform zur Klärung von Online-Streitigkeiten bereit. Diese Plattform dient als eine zentrale Anlaufstelle für Verbraucher und Unternehmer, die Streitigkeiten außergerichtlich beilegen möchten. Unter folgendem Link können Sie diese aufrufen: www.ec.europa.eu/consumers/odr',
        ],
      },
      {
        heading: 'Versicherungsombudsfrau',
        paragraphs: [
          '          Bei Beschwerden haben Sie auch die Möglichkeit sich an die Versicherungsombudsfrau zu wenden. Diese außergerichtliche Schlichtungsstelle vermittelt bei Meinungsverschiedenheiten zwischen Versicherungsnehmern und Versicherern. Die Ombudsfrau für Versicherungen ist eine unabhängige und für Verbraucher kostenfrei arbeitende Schlichtungsstelle.',
          'Versicherungsombudsmann e.V.',
          'Postfach 080632',
          '10006 Berlin',
          'Tel.<0>0800 3696000*</0>',
          'Fax <1>0800 3699000*</1>',
          '<2>beschwerde@versicherungsombudsmann.de</2>',
          '<3>www.versicherungsombudsmann.de</3>',
        ],
        links: [
          'tel:0800 3696000',
          'fax:0800 3699000',
          'mailto:beschwerde@versicherungsombudsmann.de',
          'https://www.versicherungsombudsmann.de',
        ],
      },
      { heading: 'Rechtliche Hinweise' },
      {
        heading: '1. Nutzung der Website',
        paragraphs: [
          'Mit der reinen Nutzung der Website des Anbieters kommt keinerlei Vertragsverhältnis zwischen dem Nutzer und dem Anbieter zustande. Namentlich gekennzeichnete Beiträge dieser Website geben die Meinung des jeweiligen Autors und nicht immer die Meinung des Anbieters wieder.',
        ],
      },
      {
        heading: '2. Externe Links',
        paragraphs: [
          'Diese Website enthält Verknüpfungen zu Websites Dritter ("externe Links"). Diese Websites unterliegen der Haftung der jeweiligen Betreiber. Domestic & General hat bei der erstmaligen Verknüpfung der externen Links die fremden Inhalte daraufhin überprüft, ob etwaige Rechtsverstöße bestehen. Zu dem Zeitpunkt waren keine Rechtsverstöße ersichtlich. Domestic & General hat keinerlei Einfluss auf die aktuelle und zukünftige Gestaltung und auf die Inhalte der verknüpften Seiten. Das Setzen von externen Links bedeutet nicht, dass sich Domestic & General die hinter dem Verweis oder Link liegenden Inhalte zu Eigen macht. Eine ständige Kontrolle der externen Links ist für den Anbieter ohne konkrete Hinweise auf Rechtsverstöße nicht zumutbar. Bei Kenntnis von Rechtsverstößen werden jedoch derartige externe Links unverzüglich gelöscht. Domestic & General bittet um entsprechende Hinweise.',
        ],
      },
      {
        heading: '3. Urheber- und Leistungsschutzrechte',
        paragraphs: [
          'Die auf dieser Website veröffentlichten Inhalte unterliegen dem deutschen Urheber- und Leistungsschutzrecht. Jede vom deutschen Urheber- und Leistungsschutzrecht nicht zugelassene Verwertung bedarf der vorherigen schriftlichen Zustimmung von Domestic & General oder jeweiligen Rechteinhabers. Dies gilt insbesondere für Vervielfältigung, Bearbeitung, Übersetzung, Einspeicherung, Verarbeitung bzw. Wiedergabe von Inhalten in Datenbanken oder anderen elektronischen Medien und Systemen. Inhalte und Rechte Dritter sind dabei als solche gekennzeichnet. Die unerlaubte Vervielfältigung oder Weitergabe einzelner Inhalte oder kompletter Seiten ist nicht gestattet und strafbar. Lediglich die Herstellung von Kopien und Downloads für den persönlichen, privaten und nicht kommerziellen Gebrauch ist erlaubt.',
          'Die Darstellung dieser Website in fremden Frames ist nur mit schriftlicher Erlaubnis zulässig.',
        ],
      },
      {
        heading: '4. Datenschutz',
        paragraphs: [
          'Informationen zur Verarbeitung personenbezogener Daten bei der Nutzung unserer Website (z. B. Server-Logdateien, Kontaktaufnahme, Cookies/Tracking, Empfänger, Speicherdauer, Rechte der betroffenen Personen) finden Sie in unseren Datenschutz- und Cookie-Richtlinien: [<0>www.domesticandgeneral.com/candy</0>]. [<1>haier.domesticandgeneral.com/register/cookies</1>].',
          'Bitte beachten Sie: Bei der Kommunikation per E-Mail können Sicherheitslücken bestehen; vollständige Datensicherheit kann nicht gewährleistet werden.',
          'Die Verwendung der Kontaktdaten des Impressums zur gewerblichen Werbung ist ausdrücklich nicht erwünscht, es sei denn Domestic & General hatte zuvor seine schriftliche Einwilligung erteilt oder es besteht bereits eine Geschäftsbeziehung. Domestic & General und alle auf dieser Website genannten Personen widersprechen hiermit jeder kommerziellen Verwendung und Weitergabe ihrer Daten.',
        ],
        links: [
          'https://www.domesticandgeneral.com/candy',
          'https://haier.domesticandgeneral.com/register/cookies',
        ],
      },
    ],
  },
};
